import { createApi } from '@reduxjs/toolkit/query/react';
import { Settings } from '@tests/types';

import { ApiPath } from '@/constants';
import { createUrl } from '@/utils';

import { authGuardQuery } from './queries';

export const settingsApi = createApi({
  baseQuery: authGuardQuery,
  endpoints: (build) => ({
    getSettings: build.query<Settings, void>({
      query: () => ({
        method: 'GET',
        url: createUrl(ApiPath.Settings),
      }),
    }),
  }),
  reducerPath: 'settingsApi',
  tagTypes: ['Settings'],
});

export const { useGetSettingsQuery } = settingsApi;
